export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-O-front-side-back-twist-WEB-Large-3e2d371c7862e20fa3a661310fe6ad48.jpg";